import React from 'react';
import { Tooltip, Typography } from '@mui/material';

// What mapping a label changes, from the listing's `products` ({ total, without, current: [{value, n}] }):
// products that carry the label, how many have no value yet (they get the mapped type on the
// next nightly pass) and what the others hold today (a re-map moves them the same night;
// for patterns a product whose photo's top label is another pattern keeps that one).
// Daniel, 2026-10-22: re-maps used to reach only the gaps, invisibly.
export function impactSentence(products, kind) {
  if (!products || !products.total) return `No active product carries this label.`;
  const parts = [`${products.total} active product${products.total === 1 ? '' : 's'} carry this label`];
  if (products.without) parts.push(`${products.without} without a ${kind} yet`);
  const current = (products.current || []).slice(0, 3).map(c => `${c.n} currently ${c.value}`);
  return parts.concat(current).join(' · ');
}

export default function MappingImpact({ products, kind, compact = true }) {
  if (!products || !products.total) {
    return <Typography variant="body2" color="text.secondary">-</Typography>;
  }
  const current = (products.current || []).slice(0, 3).map(c => `${c.value} ${c.n}`).join(', ');
  if (!compact) {
    return <Typography variant="body2" color="text.secondary">{impactSentence(products, kind)}</Typography>;
  }
  return (
    <Tooltip title={impactSentence(products, kind)}>
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        <strong>{products.without}</strong>
        <Typography component="span" variant="body2" color="text.secondary"> / {products.total}</Typography>
        {current && <Typography component="span" variant="caption" color="text.secondary" sx={{ display: 'block' }}>{current}</Typography>}
      </Typography>
    </Tooltip>
  );
}
